import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight, Check, Mail } from 'lucide-react';

export default function FinalCta2({ onCta }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setTimeout(() => onCta(), 1000);
    }
  };

  return (
    <section className="py-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="relative bg-gradient-to-br from-brand-600 via-brand-700 to-accent-600 rounded-3xl p-8 sm:p-12 text-white overflow-hidden">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />

          <div className="relative text-center">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold leading-tight mb-4">
              El mejor momento para ordenar tus finanzas fue hace 5 años.
              <br />
              <span className="text-yellow-300">El segundo mejor es hoy.</span>
            </h2>
            <p className="text-lg text-white/80 mb-8 max-w-xl mx-auto">
              Únete a más de 12,000 personas que ya tomaron el control de su dinero.
            </p>

            {/* Email form */}
            {!isSubmitted ? (
              <form onSubmit={handleSubmit} className="max-w-md mx-auto">
                <div className="flex flex-col sm:flex-row gap-3">
                  <div className="relative flex-1">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="tu@email.com"
                      className="w-full pl-10 pr-4 py-4 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-white/50"
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    className="bg-white text-brand-700 font-bold py-4 px-8 rounded-xl hover:bg-gray-100 transition-all active:scale-[0.98] flex items-center justify-center gap-2 shadow-lg"
                  >
                    Comenzar
                    <ArrowRight size={18} />
                  </button>
                </div>
                <p className="text-xs text-white/60 mt-3">
                  ✓ No requiere tarjeta • ✓ Setup en 30 segundos • ✓ Cancela cuando quieras
                </p>
              </form>
            ) : (
              <div className="flex items-center justify-center gap-2 text-emerald-300">
                <Check size={24} />
                <span className="text-lg font-semibold">¡Gracias! Redirigiendo...</span>
              </div>
            )}

            {/* Trust badges */}
            <div className="flex flex-wrap justify-center gap-6 mt-8 text-sm text-white/70">
              <span className="flex items-center gap-1.5">
                <Check size={16} />
                Gratis para empezar
              </span>
              <span className="flex items-center gap-1.5">
                <Check size={16} />
                Datos encriptados
              </span>
              <span className="flex items-center gap-1.5">
                <Check size={16} />
                Soporte humano
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
